module.exports = __webpack_public_path__ + "static/media/channel-transfers.70ee4caa.svg";